// // 2025-11-06 之前版
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import zhCN from 'antd/locale/zh_CN'
// import 'dayjs/locale/zh-cn'
// import dayjs from 'dayjs';
// import { BrowserRouter } from 'react-router-dom';
// import { ConfigProvider, message } from 'antd';
// const root = ReactDOM.createRoot(document.getElementById('root'));
// message.config({
//   duration:2,
//   maxCount:3,
// })
// dayjs.locale('cn')
// root.render(
//   <BrowserRouter>
//     <ConfigProvider locale={zhCN}>
//       <App />
//     </ConfigProvider>
//   </BrowserRouter>
// );

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, message } from 'antd';
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'
import './index.css';
import App from './App';

// 初始化国际化配置（集中管理）
const initI18n = () => {
  // 配置dayjs中文 locale
  dayjs.locale('zh-cn');
};

// 初始化全局组件配置
const initGlobalConfig = () => {
  // 配置message全局默认参数
  message.config({
    duration: 2,         // 消息自动关闭时间（秒）
    maxCount: 3,         // 最多同时显示消息数
    top: 24,             // 消息距离顶部距离（px），优化视觉体验
  });
};

// 执行初始化操作
initI18n();
initGlobalConfig();

// 获取根节点并渲染
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  // 使用React.StrictMode开启严格模式，帮助检测潜在问题
  root.render(
    <BrowserRouter>
        {/* 配置antd全局国际化 */}
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  );
} else {
  // 根节点不存在时给出明确错误提示
  console.error('无法找到id为"root"的DOM元素，应用无法渲染');
}